var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wrapper",
          attrs: { id: "globalModal" },
          on: { click: _vm.onClose },
        },
        [
          _c(
            "div",
            {
              class: { "global_modal wrapper_body card": true },
              style: { width: _vm.modalWidth + "%" },
            },
            [
              _vm.actualData?.headerText
                ? _c("div", { staticClass: "card-header" }, [
                    _c("h4", { staticClass: "m-0" }, [
                      _vm._v(_vm._s(_vm.actualData.headerText)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "loading_div" },
                    [
                      _c("pulse-loader", {
                        staticClass: "text-center",
                        attrs: {
                          loading: _vm.loading,
                          color: _vm.loadingColor,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "modal_body card-body" },
                    [
                      _c(
                        _vm.activeComponent,
                        _vm._b(
                          {
                            ref: `ref_${_vm.activeComponent}`,
                            tag: "component",
                            attrs: { data: _vm.actualData },
                          },
                          "component",
                          _vm.actualData,
                          false
                        )
                      ),
                      _vm._v(" "),
                      _vm.actualData.messageText
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.actualData.messageText),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-footer flex justify-content-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: {
                        click: function ($event) {
                          return _vm.onClose(null, true)
                        },
                      },
                    },
                    [_vm._v("Отмена")]
                  ),
                  _vm._v(" "),
                  _vm.extraBtnText
                    ? _c("LoadingButton", {
                        attrs: {
                          title: _vm.extraBtnText,
                          loading: _vm.loadingButton,
                          onClick: () => _vm.save(true),
                          className: "btn btn-outline-warning ml-1",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: _vm.acceptBtnText,
                      loading: _vm.loadingButton,
                      onClick: () => _vm.save(),
                      className: "btn btn-success ml-1",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }